
export const authTypes = {
    InitAction  : 'Init_Action',
    NewError    : 'New_Error',
    RegisterUser: 'Register_User',
    LoginUser   : 'Login_User',
    LogoutUser  : 'Logout_User'
}